/* eslint-disable no-console */
<template>
  <div class="edit_box">
    <!-- <el-button class="edit_button" type="info" @click="setisDetail()" plain>{{
      parentData.isDetail ? "编辑" : "取消编辑"
    }}</el-button> -->
    <div class="line1">
      <div class="line1_left">{{ title }}</div>
      <div class="line1_right" @click="setisDetail" v-if="title !== '详情'">
        {{ parentData.isDetail ? "编辑" : "取消编辑" }}
      </div>
    </div>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="140px"
      :disabled="parentData.isDetail"
    >
      <!-- :class="{ pitch_on: !!form.travelIsup == 1 }" -->
      <div class="mode_box">
        <div class="card_info">车辆信息</div>

        <!-- 车辆证件 -->
        <el-row style="padding-right:80px;">
          <el-col :span="8">
            <el-form-item label="号牌号码" prop="licenseNumber">
              <el-input
                v-model="form.licenseNumber"
                placeholder="请输入号牌号码"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车辆所有人" prop="owner">
              <el-input
                v-model="form.owner"
                placeholder="请输入车辆所有人"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车辆类型" prop="classificationCode">
              <el-select
                v-model="form.classificationCode"
                placeholder="请选择车辆类型"
                clearable
              >
                <el-option
                  v-for="item in parentData.vehicleClassificationList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item
              :label="
                form.isHasTrailer == 1 ? '准牵引总质量(kg)' : '核定载质量(kg)'
              "
              prop="loadWeight"
            >
              <el-input
                v-model="form.loadWeight"
                type="number"
                placeholder="请输入质量(kg)"
              />
            </el-form-item>
          </el-col>
          <!-- 装备质量 -->
          <el-col :span="8">
            <el-form-item
              :label="
                form.isHasTrailer == 1 ? '牵引车整备质量(kg)' : '总质量(kg)'
              "
              :label-width="form.isHasTrailer == 1 ? '160px' : null"
              prop="totalWeight"
            >
              <el-input
                v-model="form.totalWeight"
                type="number"
                placeholder="请输入质量(kg)"
              />
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="能源类型" prop="vehicleEnergyType">
              <el-select
                v-model="form.vehicleEnergyType"
                placeholder="请选择车辆能源类型"
                clearable
                @change="
                  changeEnergeName(
                    form.vehicleEnergyType,
                    parentData.vehicleEnergyTypeList
                  )
                "
              >
                <el-option
                  v-for="item in parentData.vehicleEnergyTypeList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="检验有效期至" prop="vehicleLicenseDueDate">
              <el-date-picker
                v-model="form.vehicleLicenseDueDate"
                :class="form.hasDueDate ? 'disabledhide' : ''"
                placeholder="请输入有效期"
                type="date"
                value-format="yyyy-MM-dd"
                clearable
              />
              <!-- <el-input
                v-model="form.vehicleLicenseDueDate"
                placeholder="请输入检验有效期"
              /> -->
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="车辆识别代码" prop="vin">
              <el-input
                v-model="form.vin"
                placeholder="请输入车辆识别码VIN"
                clearable
              />
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <!-- todo -->
            <el-form-item label="品牌型号" prop="brandModel">
              <el-input
                v-model="form.brandModel"
                placeholder="请输入品牌型号"
                clearable
              />
            </el-form-item>
          </el-col>
          <!-- todo -->
          <el-col :span="8">
            <el-form-item label="车牌颜色" prop="vehicleLicenseColor">
              <el-select
                v-model="form.vehicleLicenseColor"
                placeholder="请选择车牌颜色"
                clearable
              >
                <el-option
                  v-for="item in parentData.vehicleLicenseColorList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="16">
            <el-col :span="8">
              <el-form-item class="dif" prop="length" label="外廓尺寸">
                <el-input
                  v-model="form.length"
                  placeholder="车辆长度"
                  clearable
                />mm
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item class="dif" prop="width" label-width="10px">
                *
                <el-input
                  v-model="form.width"
                  style="padding-left: 6px;box-sizing: border-box;"
                  placeholder="车辆宽度"
                  clearable
                />mm
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item class="dif" prop="height" label-width="10px">
                *
                <el-input
                  v-model="form.height"
                  style="padding-left: 6px;box-sizing: border-box;"
                  placeholder="车辆高度"
                  clearable
                />mm
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="8" class="Archive_Number">
            <el-form-item label="档案编号" prop="vehicleLicense">
              <el-input
                v-model="form.vehicleLicense"
                placeholder="请输入车辆行驶证档案编号"
                clearable
                @change="
                  value => {
                    form.vehicleLicense = value.replace(/\W/g, '');
                  }
                "
              />
              <div class="remarks">
                注:行驶证若不存在档案编号可埴车籍地6位行政区域代码+000000
              </div>
            </el-form-item>
          </el-col>
          <!--TODO: 车长 车型 -->
          <el-col :span="8"
            ><el-form-item label="车长" prop="carLength">
              <el-select
                v-model="form.carLength"
                placeholder="请选择车长"
                clearable
                filterable
              >
                <el-option
                  v-for="item in parentData.appVehicleLength"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车型" prop="carModel">
              <el-select
                v-model="form.carModel"
                placeholder="请选择车辆类型"
                clearable
                filterable
              >
                <el-option
                  v-for="item in parentData.appVehicleClassification"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- form.isHasTrailer == 1 -->
        </el-row>
        <el-row style="padding-right:80px;">
          <el-col :span="8">
            <el-form-item
              label="道路运输证号"
              prop="roadTransportCertificateNumber"
            >
              <el-input
                placeholder="请输入道路运输证号"
                v-model="form.roadTransportCertificateNumber"
                clearable
              />
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="业户名称" prop="owner">
              <el-input v-model="form.owner" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车辆号牌" prop="roadCarNumber">
              <el-input v-model="form.roadCarNumber" clearable />
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="经营许可证号" prop="roadTransportPermitNumber">
              <el-input
                @input="transportPermit"
                v-model="form.roadTransportPermitNumber"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="有效期至" prop="roadTransportCertificateDate">
              <el-date-picker
                v-model="form.roadTransportCertificateDate"
                :class="form.hasDueDate ? 'disabledhide' : ''"
                placeholder="请输入有效期"
                type="date"
                value-format="yyyy-MM-dd"
                clearable
              />
              <!-- <el-input
                placeholder="请输入有效期"
                v-model="form.roadTransportCertificateDate"
              /> -->
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- todo -->
            <el-form-item label="是否挂靠车辆" prop="affiliatedVehicle">
              <el-radio v-model="form.affiliatedVehicle" :label="1"
                >是</el-radio
              >
              <el-radio v-model="form.affiliatedVehicle" :label="0"
                >否</el-radio
              >
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="是否牵引车" prop="isHasTrailer">
              <el-radio v-model="form.isHasTrailer" :label="1">是</el-radio>
              <el-radio v-model="form.isHasTrailer" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="padding-right:80px;">
          <el-col :span="24">
            <el-form-item label="车辆证件">
              <!-- 车辆行驶证正页照片 -->
              <ImgReview
                lebal="车辆行驶证正页照片"
                :src="form.vehicleLicenseImg"
                error="未上传"
                v-if="parentData.isDetail"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '车辆行驶证正页照片',
                  prefix: 'vehicleLicense',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="form"
                :required="!!form.vehicleLicenseImg"
                v-else
              />
              <!-- 车辆行驶证副页照片 -->
              <ImgReview
                lebal="车辆行驶证副页照片"
                :src="form.vehicleLicenseDeputyPageImg"
                error="未上传"
                v-if="parentData.isDetail"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '车辆行驶证副页照片',
                  prefix: 'vehicleLicenseDeputyPage',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="form"
                :required="!!form.vehicleLicenseDeputyPageImg"
                v-else
              />
              <!-- 车辆行驶证补充照片 -->
              <ImgReview
                lebal="车辆行驶证补充照片"
                :src="form.vehicleLicenseSupplementImg"
                error="未上传"
                v-if="parentData.isDetail"
              />

              <ImgUpload
                :upload-config="{
                  lebal: '车辆行驶证补充照片',
                  prefix: 'vehicleLicenseSupplement',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="form"
                :required="!!form.vehicleLicenseSupplementImg"
                v-else
              />
              <!-- 道路运输证照片 -->
              <ImgReview
                lebal="道路运输证照片"
                :src="form.roadTransportCertificateImg"
                error="未上传"
                v-if="parentData.isDetail"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '道路运输证照片',
                  prefix: 'roadTransportCertificate',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="form"
                :required="!!form.roadTransportCertificateImg"
                v-else
              />

              <ImgReview
                lebal="道路运输证补充照片"
                :src="form.roadTransportCertificateDeputyImg"
                error="未上传"
                v-if="parentData.isDetail"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '道路运输证补充照片',
                  prefix: 'roadTransportCertificateDeputy',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="form"
                :required="!!form.roadTransportCertificateDeputyImg"
                v-else
              />
              <ImgReview
                lebal="车头照片"
                :src="form.vehicleImg"
                error="未上传"
                v-if="parentData.isDetail"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '车头照片',
                  prefix: 'vehicle',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="form"
                :required="false"
                v-else
              />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <!-- 挂车信息  :class="{ pitch_on: !!form.operateIsup == 1 }"-->
      <div class="mode_box" v-if="form.isHasTrailer === 1">
        <div class="card_info">挂车信息</div>
        <el-row style="padding-right:80px;">
          <el-col :span="8">
            <el-form-item label="号牌号码" prop="trailerNum">
              <el-input
                v-model="form.trailerNum"
                placeholder="请输入号牌号码"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车辆类型" prop="trailerClassificationCode">
              <el-select
                v-model="form.trailerClassificationCode"
                placeholder="请选择车辆类型"
                clearable
                filterable
              >
                <el-option
                  v-for="item in parentData.vehicleClassificationList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- todo -->
            <el-form-item label="车辆所有人" prop="trailerOwner">
              <el-input
                v-model="form.trailerOwner"
                placeholder="请输入车辆所有人"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="核定载质量(kg)" prop="trailerLoadWeight">
              <el-input v-model="form.trailerLoadWeight" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="挂车总质量(kg)" prop="trailerTotalWeight">
              <el-input v-model="form.trailerTotalWeight" />
            </el-form-item>
          </el-col>
          <!-- todo1 -->
          <el-col :span="8">
            <el-form-item
              label="检验有效期至"
              prop="trailerRoadTransportCertificateDate"
            >
              <el-date-picker
                v-model="form.trailerRoadTransportCertificateDate"
                :class="form.hasDueDate ? 'disabledhide' : ''"
                placeholder="请输入有效期"
                type="date"
                value-format="yyyy-MM-dd"
                clearable
              />
            </el-form-item>
          </el-col>
          <!-- todo2 -->
          <el-col :span="8">
            <el-form-item label="车辆识别代码" prop="trailerVin">
              <el-input
                v-model="form.trailerVin"
                placeholder="请输入车辆识别码"
                clearable
              />
            </el-form-item>
          </el-col>
          <!-- todo3 -->
          <el-col :span="8">
            <el-form-item label="档案编号" prop="trailerVehicleLicense">
              <el-input
                v-model="form.trailerVehicleLicense"
                placeholder="请输入车辆行驶证档案编号"
                clearable
                @change="
                  value => {
                    form.vehicleLicense = value.replace(/\W/g, '');
                  }
                "
              />
            </el-form-item>
          </el-col>
          <!-- todo品牌型号 -->
          <el-col :span="8">
            <!-- todo -->
            <el-form-item label="品牌型号" prop="trailerBrandModel">
              <el-input
                v-model="form.trailerBrandModel"
                placeholder="请输入品牌型号"
                clearable
              />
            </el-form-item>
          </el-col>

          <!-- todo挂车道路运输证号 -->
          <el-col :span="8">
            <el-form-item label="道路运输证号" prop="trailerRoadTransport">
              <el-input
                v-model="form.trailerRoadTransport"
                placeholder="请输入道路运输证号"
              />
              <!-- <div class="remarks">
                总质量4.5吨及以下普通货运车辆可填车籍地6位行政区代码+000000
              </div> -->
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
          <el-form-item label="挂车道路运输证号" prop="licenseNumber">
            <el-input
              v-model="form.licenseNumber"
              placeholder="请输入挂车道路运输证号"
              clearable
            />
          </el-form-item>
        </el-col> -->
          <!-- 道运证的车牌号 -->
          <!-- <el-col :span="8">
            <el-form-item
              label="车牌号码"
              prop="trailerTransportCertificateNumber"
            >
              <el-input
                v-model="form.trailerTransportCertificateNumber"
                placeholder="请输入挂车车牌号"
              />
            </el-form-item>
          </el-col> -->
          <el-col :span="8">
            <el-form-item label="车长" prop="carLengthName">
              <el-select
                v-model="form.carLengthName"
                placeholder="请选择车辆类型"
                clearable
                filterable
              >
                <el-option
                  v-for="item in parentData.vehicleLengthList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- todo车型 -->
          <el-col :span="8">
            <el-form-item label="车型" prop="TrailerModel">
              <el-input v-model="form.TrailerModel" placeholder="请输入车型" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车牌颜色" prop="trailerLicenseColor">
              <el-select
                v-model="form.trailerLicenseColor"
                placeholder="请选择车牌颜色"
                clearable
              >
                <el-option
                  v-for="item in parentData.vehicleLicenseColorList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- todo -->
            <el-form-item label="是否挂靠车辆" prop="trailerAffiliatedVehicle">
              <el-radio v-model="form.trailerAffiliatedVehicle" label="1"
                >是</el-radio
              >
              <el-radio v-model="form.trailerAffiliatedVehicle" label="0"
                >否</el-radio
              >
            </el-form-item>
          </el-col>
          <!-- todo外廓尺寸 -->
          <el-col :span="24">
            <el-col :span="6">
              <el-form-item class="dif" prop="trailerlength" label="外廓尺寸">
                <el-input
                  v-model="form.trailerlength"
                  placeholder="车辆长度"
                  clearable
                />mm
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item class="dif" prop="trailerwidth" label-width="10px">
                *
                <el-input
                  v-model="form.trailerwidth"
                  style="padding-left: 6px;box-sizing: border-box;"
                  placeholder="车辆宽度"
                  clearable
                />mm
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item class="dif" prop="trailerheight" label-width="10px">
                *
                <el-input
                  v-model="form.trailerheight"
                  style="padding-left: 6px;box-sizing: border-box;"
                  placeholder="车辆高度"
                  clearable
                />mm
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>

        <el-row style="padding-right:80px;">
          <el-col :span="24">
            <el-form-item label="挂车证件">
              <ImgReview
                lebal="行驶证主页"
                :src="form.trailerVehicleLicenseImg"
                error="未上传"
                v-if="parentData.isDetail"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '行驶证主页',
                  prefix: 'trailerVehicleLicense',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="form"
                :required="!!form.trailerVehicleLicenseImg"
                v-else
              />
              <ImgReview
                lebal="行驶证副页"
                :src="form.trailerVehicleLicenseDeputyPageImg"
                error="未上传"
                v-if="parentData.isDetail"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '行驶证副页',
                  prefix: 'trailerVehicleLicenseDeputyPage',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="form"
                :required="!!form.trailerVehicleLicenseDeputyPageImg"
                v-else
              />
              <ImgReview
                lebal="行驶证年审页"
                :src="form.trailerVehicleLicenseSupplementImg"
                error="未上传"
                v-if="parentData.isDetail"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '行驶证年审页',
                  prefix: 'trailerVehicleLicenseSupplement',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="form"
                :required="false"
                v-else
              />
              <ImgReview
                lebal="挂车照片"
                :src="form.trailerVehicleImg"
                error="未上传"
                v-if="parentData.isDetail"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '挂车照片',
                  prefix: 'trailerVehicle',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="form"
                :required="!!form.trailerVehicleImg"
                v-else
              />

              <ImgReview
                lebal="挂车道路运输证照片"
                :src="form.trailerRoadTransportCertificateImg"
                error="未上传"
                v-if="parentData.isDetail"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '挂车道路运输证照片',
                  prefix: 'trailerRoadTransportCertificate',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="form"
                :required="!!form.trailerRoadTransportCertificateImg"
                v-else
              />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <!-- 经营许可证 :class="{ pitch_on: !!form.operateIsup == 1 }"-->
      <div class="mode_box">
        <div class="card_info">经营许可证</div>
        <el-row style="padding-right:80px;">
          <el-col :span="12">
            <el-form-item label="许可证号" prop="roadPermitNumber">
              <el-input
                v-model="form.roadPermitNumber"
                placeholder="请输入许可证号"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="业主名称" prop="roadPermitName">
              <el-input v-model="form.roadPermitName" clearable />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="经营范围" prop="businessScope">
              <el-input v-model="form.businessScope" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="有效期至" prop="periodValidity">
              <el-date-picker
                v-model="form.periodValidity"
                placeholder="请输入有效期"
                :class="form.hasDueDate ? 'disabledhide' : ''"
                type="date"
                value-format="yyyy-MM-dd"
                clearable
              />
              <!-- <el-input v-model="form.periodValidity" clearable /> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="padding-right:80px;">
          <el-col :span="24">
            <el-form-item label="输经营许可证">
              <ImgReview
                lebal="道路运输经营许可证"
                :src="form.roadPermitNumberImg"
                error="未上传"
                v-if="parentData.isDetail"/>
              <ImgUpload
                :upload-config="{
                  lebal: '道路运输经营许可证',
                  prefix: 'roadPermitNumber',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="form"
                :required="!!form.roadPermitNumberImg"
                v-else
            /></el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- <div :class="{pitch_on:}"> -->
      <div class="mode_box">
        <div class="card_info">其他信息</div>
        <el-row>
          <el-col :span="6">
            <el-form-item label="车辆保险" prop="vehicleInsurance">
              <el-radio v-model="form.vehicleInsurance" label="1">是</el-radio>
              <el-radio v-model="form.vehicleInsurance" label="0">否</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="挂靠证明" prop="proofAffiliation">
              <el-radio v-model="form.proofAffiliation" label="1">是</el-radio>
              <el-radio v-model="form.proofAffiliation" label="0">否</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="上传证件">
              <ImgReview
                lebal="交强险"
                :src="form.trafficInsuranceImg"
                error="未上传"
                v-if="parentData.isDetail"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '交强险',
                  prefix: 'trafficInsurance',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="form"
                :required="!!form.trafficInsuranceImg"
                v-else
              />
              <ImgReview
                lebal="商业险"
                :src="form.comInsuranceImg"
                error="未上传"
                v-if="parentData.isDetail"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '商业险',
                  prefix: 'comInsurance',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="form"
                :required="!!form.comInsuranceImg"
                v-else
              />
              <!-- 挂靠证明 -->
              <ImgReview
                lebal="挂靠证明"
                :src="form.guakao"
                error="未上传"
                v-if="parentData.isDetail"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '挂靠证明',
                  prefix: 'comInsurance',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="form"
                :required="!!form.guakao"
                v-else
              />
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- 选填 -->
    </el-form>
    <br />
    <!-- 审核按钮 -->
    <el-row v-if="review" class="_btns">
      <el-button class="reject" type="danger" @click="showRefuse = true">
        审核驳回
      </el-button>
      <el-button
        class="adopt"
        type="primary"
        v-if="parentData.isDetail"
        @click="funcSubmit"
      >
        审核通过
      </el-button>
      <el-button
        class="adopt"
        type="primary"
        v-if="!parentData.isDetail"
        @click="submitEdit"
      >
        保存编辑
      </el-button>
    </el-row>
    <br />
    <br />
    <!-- <el-form v-if="review" ref="formData" :model="form" label-width="180px">
      <el-form-item label="" prop="authMsg">
        <el-input
          v-model="authMsg"
          placeholder="驳回意见"
          type="textarea"
          maxlength="100"
          show-word-limit
          :autosize="{ minRows: 4 }"
          clearable
        />
      </el-form-item>
    </el-form> -->
    <el-dialog
      title="驳回意见"
      :visible.sync="showRefuse"
      append-to-body
      modal-append-to-body
      width="600px"
      class="clearfix"
    >
      <el-form ref="formData" :model="form">
        <el-form-item prop="authMsg">
          <el-input
            v-model="authMsg"
            placeholder="驳回意见"
            type="textarea"
            maxlength="100"
            show-word-limit
            :autosize="{ minRows: 4 }"
            clearable
          />
        </el-form-item>
      </el-form>
      <div class="clearfix">
        <el-button @click="funcRefuse" type="primary" style="float: right;"
          >确认驳回</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  isTaxOpen,
  authCarInfo,
  carAuth,
  updateAddOrDriverTeam
} from "@/api/driver.js";
import ImgReview from "@/components/ImgReview";
import ImgUpload from "@/components/ImgUpload";
import request from "@/utils/request";
import { insuranceType } from "@/api/orderform";
export default {
  name: "DriverEdit",
  components: {
    ImgReview,
    ImgUpload
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          isDetail: false,
          areaOptions: [],
          vehicleTypeAllowList: [],
          vehicleClassificationList: [],
          vehicleLengthList: [],
          appVehicleLength: [],
          appVehicleClassification: [],
          vehicleWidthList: [],
          vehicleHighList: [],
          vehicleTonnageList: [],
          vehicleLicenseColorList: [],
          mode: "detail"
        };
      }
    },
    title: {
      type: String
    }
  },
  data() {
    return {
      rules: {
        carLength: [
          { required: true, message: "请选择车长", trigger: "change" }
        ],
        carModel: [
          { required: true, message: "请选择车型", trigger: "change" }
        ],
        trailerLicenseColor: [
          { required: true, message: "请选择车牌颜色", trigger: "blur" }
        ],
        // 车辆信息验证规则
        licenseNumber: [
          { required: true, message: "请输入号牌号码", trigger: "blur" }
        ],
        classificationCode: [
          { required: true, message: "请选择车辆类型", trigger: "change" }
        ],
        owner: [
          { required: true, message: "请输入车辆所有人", trigger: "blur" }
        ],
        loadWeight: [
          { required: true, message: "请输入质量", trigger: "blur" }
        ],
        totalWeight: [
          { required: true, message: "请输入质量", trigger: "blur" }
        ],
        vehicleLicenseDueDate: [
          { required: true, message: "请选择检验有效期", trigger: "change" }
        ],
        vin: [
          { required: true, message: "请输入车辆识别代码", trigger: "blur" }
        ],
        vehicleLicense: [
          { required: true, message: "请输入档案编号", trigger: "blur" }
        ],
        length: [
          { required: true, message: "请输入车辆长度", trigger: "blur" }
        ],
        width: [{ required: true, message: "请输入车辆宽度", trigger: "blur" }],
        height: [
          { required: true, message: "请输入车辆高度", trigger: "blur" }
        ],
        roadTransportCertificateNumber: [
          { required: true, message: "请输入道路运输证号", trigger: "blur" }
        ],
        owner: [{ required: true, message: "请输入业户名称", trigger: "blur" }],
        roadCarNumber: [
          { required: true, message: "请输入车辆号牌", trigger: "blur" }
        ],
        roadTransportPermitNumber: [
          { required: true, message: "请输入经营许可证号", trigger: "blur" }
        ],
        roadTransportCertificateDate: [
          { required: true, message: "请选择有效期", trigger: "change" }
        ],
        isHasTrailer: [
          { required: true, message: "请选择", trigger: "change" }
        ],

        // 挂车信息验证规则
        trailerNum: [
          { required: true, message: "请输入号牌号码", trigger: "blur" }
        ],
        trailerClassificationCode: [
          { required: true, message: "请选择车辆类型", trigger: "change" }
        ],
        traileVehicleOwner: [
          { required: true, message: "请输入车辆所有人", trigger: "blur" }
        ],
        trailerLoadWeight: [
          { required: true, message: "请输入核定载质量", trigger: "blur" }
        ],
        trailerTotalWeight: [
          { required: true, message: "请输入挂车总质量", trigger: "blur" }
        ],
        // trailerVehicleLicenseDueDate: [
        //   { required: true, message: "请选择检验有效期", trigger: "change" }
        // ],
        trailerRoadTransport: [
          { required: true, message: "请输入道路运输证号", trigger: "blur" }
        ],
        // plateNum: [
        //   { required: true, message: "请输入车牌号码", trigger: "blur" }
        // ],

        // 经营许可证验证规则
        roadPermitNumber: [
          { required: true, message: "请输入许可证号", trigger: "blur" }
        ],
        // trailerVin: [
        //   { required: true, message: "挂车的车辆识别码", trigger: "blur" }
        // ],
        trailerTransportCertificateNumber: [
          { required: true, message: "挂车的道运证车牌号", trigger: "blur" }
        ]
        // trailerRoadTransportCertificateDate: [
        //  { required: true, message: "挂车道路运输证的有效期", trigger: "blur" }
        // ]
      },
      showRefuse: false,
      showExtra: true,
      ctmsShow: true,
      hasTaxOpen: "",
      authMsg: "",
      otherItems: true,
      linkageInvalid: true,
      submitShow: true,
      reportProvinceName: "",
      code: "",
      form: {
        isHasTrailer: 0,
        brandModel: "", //车头品牌型号
        owner: "", //车辆所有人
        affiliatedVehicle: "", //车头挂靠车辆
        traileVehicleOwner: "", // 挂车车辆所有人
        trailerVehicleLicenseDueDate: "", //挂车检验有效期至
        trailerVehicleLicense: "", // 挂车档案编号
        trailerBrandModel: "", //  挂车品牌型号
        trailerlength: "", //挂车外廓尺寸：车辆长度
        trailerwidth: "", //  车辆宽度
        trailerheight: "", //车辆高度
        plateNum: "", // 挂车的车牌号码
        TrailerModel: "", // 挂车车型
        trailerAffiliatedVehicle: "" //  挂车是否是挂靠车辆
      },
      // 挂车
      isHasTrailerOptions: [
        { label: "否", value: 0 },
        { label: "是", value: 1 }
      ],
      // 挂靠车辆
      isLinkedOptions: [{ label: "否", value: 0 }, { label: "是", value: 1 }],
      // 是否清分
      isShareOptions: [{ label: "否", value: 0 }, { label: "是", value: 1 }]
    };
  },
  computed: {
    compTrailer() {
      return this.form.isHasTrailer === 1 ? true : false;
    },
    review() {
      return this.parentData.model === "review" ? true : false;
    }
  },
  watch: {
    "form.isHasTrailer": {
      handler(newVal) {
        // 当isHasTrailer为1时，添加挂车相关字段的必填校验
        // 当isHasTrailer为0时，移除挂车相关字段的必填校验
        if (newVal === 1) {
          this.rules = {
            ...this.rules,
            trailerNum: [
              { required: true, message: "请输入号牌号码", trigger: "blur" }
            ],
            trailerClassificationCode: [
              { required: true, message: "请选择车辆类型", trigger: "change" }
            ],
            trailerLoadWeight: [
              { required: true, message: "请输入核定载质量", trigger: "blur" }
            ],
            trailerTotalWeight: [
              { required: true, message: "请输入挂车总质量", trigger: "blur" }
            ],
            // trailerRoadTransportCertificateDate: [
            //   {
            //     required: true,
            //     message: "挂车道路运输证的有效期",
            //     trigger: "blur"
            //   }
            // ],
            // trailerVin: [
            //   { required: true, message: "挂车的车辆识别码", trigger: "blur" }
            // ],
            trailerRoadTransport: [
              { required: true, message: "请输入道路运输证号", trigger: "blur" }
            ],
            trailerTransportCertificateNumber: [
              { required: true, message: "挂车的道运证车牌号", trigger: "blur" }
            ],
            trailerLicenseColor: [
              { required: true, message: "请选择车牌颜色", trigger: "change" }
            ]
          };
          // this.rules.trailerNum = [
          //   { required: true, message: "请输入号牌号码", trigger: "blur" }
          // ];
          // this.rules.trailerClassificationCode = [
          //   { required: true, message: "请选择车辆类型", trigger: "change" }
          // ];
          // this.rules.trailerLoadWeight = [
          //   { required: true, message: "请输入核定载质量", trigger: "blur" }
          // ];
          // this.rules.trailerTotalWeight = [
          //   { required: true, message: "请输入挂车总质量", trigger: "blur" }
          // ];
          // this.rules.trailerRoadTransportCertificateDate = [
          //   {
          //     required: true,
          //     message: "挂车道路运输证的有效期",
          //     trigger: "blur"
          //   }
          // ];
          // this.rules.trailerVin = [
          //   { required: true, message: "挂车的车辆识别码", trigger: "blur" }
          // ];
          // this.rules.trailerRoadTransport = [
          //   { required: true, message: "请输入道路运输证号", trigger: "blur" }
          // ];
          // this.rules.trailerTransportCertificateNumber = [
          //   { required: true, message: "挂车的道运证车牌号", trigger: "blur" }
          // ];
          // this.rules.trailerLicenseColor = [
          //   { required: true, message: "请选择车牌颜色", trigger: "change" }
          // ];
        } else {
          // 移除必填校验
          this.rules.trailerNum = [];
          this.rules.trailerClassificationCode = [];
          this.rules.trailerLoadWeight = [];
          this.rules.trailerTotalWeight = [];
          this.rules.trailerRoadTransportCertificateDate = [];
          this.rules.trailerVin = [];
          this.rules.trailerRoadTransport = [];
          this.rules.trailerTransportCertificateNumber = [];
          this.rules.trailerLicenseColor = [];
        }
      },
      immediate: true // 组件创建时立即执行一次
    }
  },
  created() {
    this.reportProvinceName = this.reportProvince();
    this.form = {
      vehicleVO: {}
    };
    isTaxOpen().then(res => {
      this.hasTaxOpen = res.data;
    });
  },
  methods: {
    changeEnergeName(type, list) {
      let res = list.filter(item => {
        return item.code === type;
      });
      this.form.vehicleEnergyTypeName = res[0] ? res[0].name : "";
    },
    transportPermit(data) {
      // console.log("transportPermit",data)
      this.form.roadPermitNumber = data;
    },
    setisDetail() {
      this.parentData.isDetail = !this.parentData.isDetail;
    },
    submitEdit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          updateAddOrDriverTeam(this.form).then(response => {
            this.$message({
              message: "编辑成功",
              type: "success"
            });
            this.setisDetail();
          });
        } else {
          return false;
        }
      });
    },
    getDriver(code) {
      this.code = code;
      authCarInfo({ code: code }).then(response => {
        let vehicleVO = response.data.vehicleVO || {};
        this.form = Object.assign({}, response.data, vehicleVO);
        console.log("获取详细信息========", this.form);
        this.authMsg = response.data.authMsg || "";
        this.$set(this.form, "areaList", []);
        if (
          this.form.provinceCode &&
          this.form.cityCode &&
          this.form.countyCode
        ) {
          this.form.areaList.push(
            this.form.provinceCode,
            this.form.cityCode,
            this.form.countyCode
          );
        }
        this.$set(
          this.form,
          "hasDueDate",
          this.form.idCardDueDate == "9999-12-31"
        );
        this.$set(
          this.form,
          "hasDriverDueDate",
          this.form.driverLicenseDueDate == "9999-12-31"
        );
      });
      insuranceType(this.instype).then(response => {
        this.locationSourceoptions = response.data.records;
      });
    },
    // 同意审核
    funcSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const rLoading = this.openLoading();
          carAuth({ code: this.code, authStatus: 3 }).then(response => {
            rLoading.close();
            this.$message({
              message: response.msg,
              type: "success"
            });
            this.$emit("fatherMethods");
          });
        }
      });
    },
    // 拒绝审核
    funcRefuse() {
      if (this.authMsg.trim() == "") {
        this.$message.warning("请输入驳回原因");
        return;
      }
      const rLoading = this.openLoading();
      carAuth({
        code: this.code,
        authStatus: 2,
        authMsg: this.authMsg
      }).then(response => {
        rLoading.close();
        this.$message({
          message: response.msg,
          type: "success"
        });
        this.$emit("fatherMethods");
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.mode_box {
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #f0f3f8;
  margin-top: 45px;
  overflow: hidden;
  margin-bottom: 18px;
  .card_info {
    width: 100%;
    height: 62px;
    line-height: 62px;
    background: #f0f3f8;
    border-radius: 0px 0px 0px 0px;
    font-weight: bold;
    font-size: 18px;
    color: #1169e9;
    padding-left: 15px;
    margin-bottom: 43px;
  }
}
.line1 {
  width: 100%;
  height: 45px;
  border-bottom: 2px solid #1169e9;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .line1_left {
    width: 171px;
    height: 45px;
    line-height: 45px;
    background-image: url("~@/assets/tms/detail.png");
    background-size: 171px 45px;
    color: #ffffff;
    font-weight: 600;
    font-size: 14px;
    padding-left: 54px;
  }
  .line1_right {
    width: 99px;
    height: 36px;
    background: #1169e9;
    border-radius: 3px 3px 3px 3px;
    text-align: center;
    line-height: 36px;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
}
._btns {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .reject {
    width: 160px;
    height: 46px;
    background: #ef4141;
    border-radius: 4px 4px 4px 4px;
    font-weight: bold;
    font-size: 14px;
    color: #ffffff;
    margin-right: 16px;
  }
  .adopt {
    width: 160px;
    height: 46px;
    background: #4186ef;
    border-radius: 4px 4px 4px 4px;
    font-weight: bold;
    font-size: 14px;
    color: #ffffff;
  }
}
.el-cascader {
  width: 100%;
}
.el-select {
  width: 100%;
}
.el-date-editor {
  width: 100%;
}
.remarks {
  color: #d01415;
  font-size: 11px;
}
::v-deep .dif {
  .el-form-item__content {
    display: flex;
    .el-input {
      flex: 1;
      margin-right: 20px;
    }
    .el-input:last-child {
      margin-right: 0;
    }
  }
}
.pitch_on {
  border: 1px solid #ff2c2c;
  padding: 6px 12px;
  box-sizing: border-box;
  margin: 12px 0;
}

.edit_box {
  position: relative;
  .edit_button {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 9;
  }
}
.card_info {
  width: 100%;
  height: 62px;
  line-height: 62px;
  background: #f0f3f8;
  border-radius: 0px 0px 0px 0px;
  font-weight: bold;
  font-size: 18px;
  color: #1169e9;
  padding-left: 15px;
  margin-bottom: 43px;
}
.Archive_Number {
  position: relative;
  margin-bottom: 17px;
  .remarks {
    position: absolute;
    bottom: -40px;
    line-height: 13px !important;
  }
}
</style>
/* eslint-enable no-console */
